import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface DiagnosticResetState {
  value: {
    // Ever-changing key (a timestamp) bumped whenever a diagnostic is reset, so the
    // dashboard's useEffect re-runs and refetches getDiagnosticStatusReport. A boolean
    // wouldn't work: it wouldn't change between two consecutive resets.
    resetKey: number;
  };
}

const initialState: DiagnosticResetState = { value: { resetKey: 0 } };

export const diagnosticResetSlice = createSlice({
  name: 'diagnosticReset',
  initialState,
  reducers: {
    setDiagnosticResetKey: (state: DiagnosticResetState, action: PayloadAction<number>) => {
      state.value.resetKey = action.payload;
    },
  },
});

export const selectedDiagnosticReset = (state: RootState) => state.diagnosticReset.value;

export const { setDiagnosticResetKey } = diagnosticResetSlice.actions;

export default diagnosticResetSlice.reducer;
